import React, { Component } from "react";
import { t } from "../../../components/CustomComponent.js";
import HomeMedia from "./HomeMedia.js";
import ICON from "../icons.js";
import { getPost, loadPost, subscribePost } from "../../../services/home_post.service.js";
import { hasBannerText } from "../../../components/homepage_option.js";

/* ============================================================================
 * HomePromo — แบนเนอร์โปรโมตโครงการ (เลื่อนอัตโนมัติ) + การ์ดลงประกาศฟรีด้านขวา
 * รายการแบนเนอร์แก้ไข/เรียงลำดับ/เปิด-ปิดได้จากหลังบ้าน (/ad/home/banners)
 *
 * กรอบแบนเนอร์ยึดสัดส่วนไฟล์ภาพมาตรฐาน 1920 x 830 (ตั้งไว้ใน CSS) และถ้าใบไหนมีรูป
 * ก็ยึดสัดส่วนจริงของไฟล์นั้นแทน รูปจึงเต็มกรอบพอดี ไม่โดนครอบตัดและไม่มีแถบว่างเหลือ
 *
 * ฉากมืดคลุมรูปเป็นตัวเลือกรายใบ (veil) ปิดไว้เป็นค่าตั้งต้น — เปิดเมื่อจะพิมพ์ข้อความ
 * ทับรูปที่สว่างจนตัวอักษรสีขาวจม ส่วนใบที่ไม่ได้กรอกข้อความเลยก็ขึ้นเป็นรูปล้วน
 * ช่องไหนไม่ได้กรอก บรรทัดนั้นก็ไม่ขึ้นเลย
 *
 * การ์ดด้านขวาเหลือใบเดียวสูงเท่าแบนเนอร์ (เดิมซ้อนกัน 2 ใบ) เพราะช่องทาง
 * "ปรึกษาอสังหาฯ" ถูกย้ายไปรวมกับแถบติดต่อก่อนฟุตเตอร์แล้ว จะได้ไม่ชวนซ้ำซ้อน
 *
 * รูปในการ์ดตั้งได้จากหลังบ้าน (/ad/home/post) — ยังไม่ตั้งก็ใช้ภาพจำลองเหมือนเดิม
 * อ่านผ่าน home_post.service ตัวเดียวกับที่ปุ่มลงประกาศฟรีใช้หา LINE ID
 * ========================================================================== */
const AUTOPLAY_MS = 6000;

export default class HomePromo extends Component {
  state = { index: 0, post: getPost(), ratios: {} };

  slides = () => this.props.banners || [];

  /* ใบรูปล้วนต้องสูงเท่าสัดส่วนจริงของไฟล์ ไม่ใช่สัดส่วนมาตรฐาน — อ่านได้หลังรูปโหลดเสร็จ
     จำไว้ต่อ id ครั้งเดียวพอ กัน setState ซ้ำตอนสไลด์วนกลับมาใบเดิม */
  keepRatio = (id, event) => {
    const { naturalWidth: width, naturalHeight: height } = event.target;
    if (!width || !height) return;
    this.setState((s) => (s.ratios[id] ? null : { ratios: { ...s.ratios, [id]: width / height } }));
  };

  componentDidMount() {
    this.timer = setInterval(this.next, AUTOPLAY_MS);
    this.unsubscribePost = subscribePost((post) => this.setState({ post }));
    loadPost(); // ยิงครั้งเดียวต่อการเปิดเว็บ — เรียกซ้ำได้ ตัว service กันไว้ให้แล้ว
  }

  componentDidUpdate(prevProps) {
    // แบนเนอร์มาทีหลัง (โหลดจาก API เสร็จ) ให้เริ่มนับจากใบแรกใหม่
    if (prevProps.banners !== this.props.banners) this.setState({ index: 0 });
  }

  componentWillUnmount() {
    clearInterval(this.timer);
    if (this.unsubscribePost) this.unsubscribePost();
  }

  // ผู้ใช้กดเลื่อนเอง : รีเซ็ตนาฬิกา จะได้ไม่โดนเลื่อนซ้อนทันที
  restart = () => {
    clearInterval(this.timer);
    this.timer = setInterval(this.next, AUTOPLAY_MS);
  };

  go = (index) => {
    const total = this.slides().length;
    if (!total) return;
    this.setState({ index: (index + total) % total });
    this.restart();
  };

  next = () => this.setState((s) => ({ index: (s.index + 1) % Math.max(1, this.slides().length) }));

  render() {
    const { index, post, ratios } = this.state;
    const { onPost } = this.props;
    const list = this.slides();

    /* กรอบยึดสัดส่วนจริงของไฟล์ที่กำลังโชว์ (พอรูปโหลดเสร็จ) แทนสัดส่วนมาตรฐาน
       1920 x 830 รูปจึงเต็มกรอบพอดีเสมอ ไม่เหลือแถบว่างและไม่โดนครอบตัด
       ใบรูปล้วน (ไม่ได้กรอกข้อความสักช่อง) ไม่ต้องเว้นระยะขอบให้ตัวอักษรด้วย */
    const current = list[index];
    const media = !!current && !!current.src && !hasBannerText(current);
    const ratio = current?.src ? ratios[current.id] : 0;

    return (
      <div className="hm-container">
        <div className="hm-promo">
          {/* ------------------------------------------------- แบนเนอร์ */}
          <div className={`hm-banner ${media ? "hm-banner--media" : ""}`} style={ratio ? { "--hm-banner-ratio": ratio } : undefined}>
            {list.map((item, i) => {
              /* ช่องไหนไม่ได้กรอกก็ไม่ต้องมีบรรทัดนั้น ไม่มีข้อความสำรองมาเติมให้ */
              const left = !!(item.kicker || item.title || item.sub);

              return (
                <div
                  key={item.id}
                  className={`hm-banner__slide ${i === index ? "is-active" : ""}`}
                  style={{ background: item.theme }}
                  aria-hidden={i !== index}
                >
                  {/* รูปพื้นหลังไม่บังคับ — ไม่มีก็เห็นสีจาก theme อย่างเดียวเหมือนเดิม
                      ฉากมืดคลุมรูปขึ้นเฉพาะใบที่เลือกไว้ (ตั้งจากหลังบ้าน) ค่าตั้งต้นคือไม่คลุม */}
                  {!!item.src && (
                    <>
                      <img
                        className="hm-banner__bg"
                        src={item.src}
                        alt=""
                        aria-hidden="true"
                        onLoad={(e) => this.keepRatio(item.id, e)}
                        /* รูปที่อยู่ในแคชอยู่แล้วบางทีโหลดเสร็จก่อน React ผูก onLoad จึงวัดจาก ref ซ้ำอีกทาง */
                        ref={(el) => el?.complete && this.keepRatio(item.id, { target: el })}
                      />
                      {!!item.veil && <span className="hm-banner__veil" />}
                    </>
                  )}

                  {left && (
                    <div className="hm-banner__left">
                      {!!item.kicker && <div className="hm-banner__kicker">{item.kicker}</div>}
                      {!!(item.title || item.sub) && (
                        <div className="hm-banner__title">
                          {item.title}
                          {!!item.sub && <small>{item.sub}</small>}
                        </div>
                      )}
                      {!!item.cta && (
                        <span className="hm-banner__tag">
                          <span className="hm-ico">{ICON.star}</span>
                          {t(item.cta)}
                        </span>
                      )}
                    </div>
                  )}

                  {!!(item.brand || item.brand_sub) && (
                    <div className="hm-banner__mid">
                      <div className="hm-banner__logo">
                        {item.brand}
                        {!!item.brand_sub && <small>{item.brand_sub}</small>}
                      </div>
                    </div>
                  )}

                  {!!(item.headline || item.detail || item.price) && (
                    <div className="hm-banner__right">
                      {!!item.headline && <p>{item.headline}</p>}
                      {!!item.detail && <p className="hm-banner__detail">{item.detail}</p>}
                      {!!item.price && (
                        <div className="hm-banner__price">
                          {t("home_banner_start")}
                          <b>{item.price}</b>
                          {item.price_unit || t("home_banner_unit")}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}

            {/* เลื่อนสไลด์ด้วยลูกศรที่วางทับรูปอย่างเดียว ไม่มีแถบจุดมาคาดใต้รูปให้เกะกะ
                ใบเดียวไม่มีอะไรให้เลื่อน ปุ่มก็ไม่ต้องขึ้นมาบังรูป */}
            {list.length > 1 && (
              <>
                <button type="button" className="hm-banner__nav is-prev" aria-label="prev" onClick={() => this.go(index - 1)}>
                  <span className="hm-ico">{ICON.chevron_left}</span>
                </button>
                <button type="button" className="hm-banner__nav is-next" aria-label="next" onClick={() => this.go(index + 1)}>
                  <span className="hm-ico">{ICON.chevron_right}</span>
                </button>
              </>
            )}
          </div>

          {/* --------------------------------------------- การ์ดด้านขวา */}
          <div className="hm-promo__side">
            <div className="hm-side-card hm-side-card--tint">
              <div className="hm-side-card__body">
                {/* ปุ่มลงประกาศฟรีอยู่มุมบนขวาของการ์ด ให้เห็นก่อนตัวคำอธิบาย */}
                <div className="hm-side-card__head">
                  <div className="hm-side-card__title">{t("home_promo_post_title")}</div>
                  <button type="button" className="hm-btn hm-btn--primary hm-btn--sm hm-side-card__cta" onClick={onPost}>
                    <span className="hm-ico">{ICON.bullhorn}</span>
                    {t("home_promo_post_cta")}
                  </button>
                </div>
                <div className="hm-side-card__desc">{t("home_promo_post_desc")}</div>
              </div>
              {/* รูปที่ตั้งไว้หลังบ้านมาก่อน ไม่มีค่อยวาดภาพจำลองเหมือนเดิม */}
              <div className="hm-side-card__art">
                {post.src ? (
                  <img className="hm-side-card__img" src={post.src} alt="" aria-hidden="true" />
                ) : (
                  <HomeMedia kind="skyline" tone={5} ratio={0.62} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
